import { Component } from '@angular/core';

@Component({
  selector: 'internal-server-error',
  templateUrl: './internal-server-error.component.html',
  styleUrls: [ '../status.less' ],
})
export class InternalServerErrorComponent {}
